import styled from "@emotion/styled";
import { SelectChangeEvent } from "@mui/material";
import { ChangeEvent, FormEvent, useState } from "react";
import { AddMobileButton, WarningIcon } from "../../assets/icons/icons";
import MobilityRegisterModal from "../../components/mobilityRegisterModal";
import SelectBox from "../../components/selectBox";
import theme from "../../theme";
import { getEventOptions, getMobileOptions } from "../../utils/constants";
import { SearchForm } from "../../components/common/SearchForm";
import { Button } from "../../components/common/Button";
import { SystemSetting } from "../../types/types";
import { FetchParams } from "./mobileList";

import Calendars from "../../components/calendars";
import { CustomAlert } from "../../components/customAlert";
import { SelectBoxGroupId } from "../../components/SelectBoxGroupId";
import { useI18n } from "../../locales";

interface subHeaderProps {
  mobFilter: number;
  mobHandleChange: (event: SelectChangeEvent<number>) => void;
  onClickBtn: ({
    startDate,
    endDate,
    searchKey,
    eventCode,
    mobFilter,
  }: FetchParams) => void;
  startFetch: () => void;
  setRealMobFilter: any;
  systemSetting: SystemSetting | null;
}

const SubHeader: React.FC<subHeaderProps> = (props) => {
  const { t } = useI18n();
  const {
    mobFilter,
    mobHandleChange,
    onClickBtn,
    startFetch,
    setRealMobFilter,
    systemSetting,
  } = props;
  const [mobFilterOpen, setMobFilterOpen] = useState(false);
  const [input, setInput] = useState("");
  const [openRegisterModal, setOpenRegisterModal] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [eventCode, setEventCode] = useState(0);
  const [filterOpen, setFilterOpen] = useState(false);
  const [groupSub, setGroupSub] = useState("all"); // 하위그룹코드(화면용)
  const [openDateAlert, setOpenDateAlert] = useState(false);

  const mobHandleClose = () => {
    setMobFilterOpen(false);
  };

  const mobHandleOpen = () => {
    setMobFilterOpen(true);
  };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInput(event.currentTarget.value);
  };

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if ((startDate && !endDate) || (endDate && !startDate)) {
      setOpenDateAlert(true);
      return;
    }

    onClickBtn({
      startDate,
      endDate,
      mobFilter,
      eventCode,
      searchKey: input,
      groupId: groupSub,
    });
    setRealMobFilter(mobFilter);
  };

  const onClickRegisterBtn = () => {
    setOpenRegisterModal(true);
  };

  const onCloseRegisterModal = () => {
    setOpenRegisterModal(false);
  };

  const handleChange = (event: SelectChangeEvent<typeof eventCode>) => {
    setEventCode(Number(event.target.value));
  };

  const handleOpen = () => {
    setFilterOpen(true);
  };
  const handleClose = () => {
    setFilterOpen(false);
  };

  return (
    <Wrapper>
      <Calendars
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        isSeparate={false}
        gap="20px"
        width={160}
        isClearable
      ></Calendars>
      <SelectBox
        open={mobFilterOpen}
        filter={mobFilter}
        handleChange={mobHandleChange}
        handleClose={mobHandleClose}
        handleOpen={mobHandleOpen}
        title={t.mobileList.selectDeviceType}
        menuItems={getMobileOptions(t)}
        width={160}
        srLabel={t.mobileList.selectDeviceType}
        mr="0px"
      />
      <SelectBox
        open={filterOpen}
        handleChange={handleChange}
        handleOpen={handleOpen}
        handleClose={handleClose}
        filter={eventCode}
        menuItems={getEventOptions(t)}
        title={t.mobileList.selectDetectionType}
        width={160}
        srLabel={t.mobileList.selectDetectionType}
        mr="0px"
      />
      {/* 하위 그룹 조회 */}
      <SelectBoxGroupId
        groupSub={groupSub}
        setGroupSub={setGroupSub}
        width={160}
      />

      <SearchForm
        onSubmit={onSubmit}
        placeholder={t.mobileList.searchDeviceOwner}
        onChange={onChange}
        inputValue={input}
        setInputValue={setInput}
        startFetch={startFetch}
        width="200px"
      />

      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: "15px",
        }}
      >
        <Button
          bgColor={theme.color.aquamarine_500}
          hoverColor={theme.color.aquamarine_600}
          onClick={onClickRegisterBtn}
          height="40px"
          isDisabled={!systemSetting?.create}
        >
          <AddMobileButtonContainer>
            <AddMobileButton />
          </AddMobileButtonContainer>
          {t.mobileList.registerDevice}
        </Button>
      </div>

      {openRegisterModal && (
        <MobilityRegisterModal
          open={openRegisterModal}
          onClose={onCloseRegisterModal}
        />
      )}

      {/* 시작일 또는 종료일 누락시 경고 얼럿 */}
      <CustomAlert
        open={openDateAlert}
        onPressOK={() => setOpenDateAlert(false)}
        title={t.control.checkDate}
        content={t.control.selectBothDates}
        confirmText={t.common.confirm}
        icon={<WarningIcon />}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 92px;
  background: ${theme.color.neutral_50};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  margin-bottom: 23px;
  gap: 18px;
`;

const AddMobileButtonContainer = styled.div`
  margin-top: 3px;
`;

export default SubHeader;
